import React, { useState } from "react";
import { Row, Col, Form, Button, Accordion, useAccordionButton } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { DashLg, PlusLg } from "react-bootstrap-icons";
import { useSelector } from "react-redux";
//import Card from "react-credit-cards-2";
import Card from "react-credit-cards";
//import "react-credit-cards-2/dist/es/styles-compiled.css";
import "react-credit-cards/es/styles-compiled.css";
import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
    formatCP,
    formatFormData
} from "../../generals/utils";
import { Alert } from "../../Alerts";
import axios from "axios";
import FAMSA from "../../../config/constants";
import { getAccountNo, getContractNo, getStore } from "../../../reducers/StepTwo";
import { useEffect } from "react";
import Loading from "../../Loading";
import { getTypePay } from "../../../reducers/TypePayment";

const ModalLoan = ({ openAccordion, CardsInfo, setAddCard, handleInputCard }) => {
    const intl = useIntl();
    const AccountNo = useSelector(getAccountNo);
    const ContractNo = useSelector(getContractNo);
    const Store = useSelector(getStore);
    const type_pay = useSelector(getTypePay);
    const [open, setOpen] = useState(openAccordion);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        number: "",
        name: "",
        expiry: "",
        cvc: "",
        cp: "",
        issuer: "",
        focused: "",
        formData: null
    });
    const [validated, setValidated] = useState({
        number: null,
        name: null,
        expiry: null,
        cvc: null,
        cp: null
    });
    const [number, setNumber] = useState("");

    const handleChange = (event) => {
        event.preventDefault();
        console.log('handleChange');
        const { target } = event;
        if (event.target.name === "number") {
            event.target.value = formatCreditCardNumber(event.target.value);
            /*const numberaux = event.target.value
            event.target.value = numberaux;
            setNumber(numberaux.replaceAll('-', ' '));*/
            setValidated({ ...validated, number: (target.value.length > 0) ? true : false });
        } else if (event.target.name === "expiry") {
            event.target.value = formatExpirationDate(event.target.value);
            setValidated({ ...validated, expiry: (target.value.length > 0) ? true : false });
        } else if (event.target.name === "cvc") {
            event.target.value = formatCVC(event.target.value);
            setValidated({ ...validated, cvc: (target.value.length > 0) ? true : false });
        } else if (event.target.name === "cp") {
            event.target.value = formatCP(event.target.value);
            setValidated({ ...validated, cp: (target.value.length > 0) ? true : false });
        } else {
            setValidated({ ...validated, name: (target.value.length > 0) ? true : false });
        }

        setState({ ...state, [event.target.name]: event.target.value });
    }

    const handleInputFocus = (event) => {
        setState({
            ...state,
            focused: event.target.name
        });
    };

    const handleCallback = ({ issuer }, isValid) => {
        if (isValid) {
            setState({ ...state, issuer });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const { number, name, expiry, cvc, cp } = validated;

        if (number && name && expiry && cvc && cp) {
            //setAddCard(true);
            const params = {
                "newCard": {
                    "name": state.name,
                    "number": state.number.trim(),
                    "expiry": state.expiry,
                    "cvc": state.cvc,
                    "zipCode": state.cp,
                    "issuer" : state.issuer
                },
                "account": AccountNo,
                "store": Store,
                "contract": ContractNo,
                "company": type_pay === 1 ? "FAMSAINC" : "LOANS"
            }
            await AddNewCard(params);
        } else {
            setAddCard(false);
            setLoading(false);
            Alert("danger", "", intl.formatMessage({id: "step.field.required"}));
        }
    };

    const AddNewCard = async (params) => {
        const fullURL = FAMSA.SERVER.SERVER + `/api/AddNewCard`;
        axios.post(fullURL, params).then((response) => {
            //console.log(response);
            setLoading(false);
            if (response.data.StatusCode === 200) {
                setAddCard(true);
                //await CardsInfo();
                setOpen(false);
                setValidated({number: null, name: null, expiry: null, cvc: null, cp: null});
                setState({number: "", name: "", expiry: "", cvc: "", cp: "", issuer: "", focused: ""});
                Alert("success", "", intl.formatMessage({id: "step.add.card"}));
            } else {
                setAddCard(false);
                Alert("danger", "Error", response.data.Message);
            }
        }).catch(error => {
            setAddCard(false);
            setLoading(false);
            if (error.response?.data?.StatusCode !== 500) {
                Alert("danger", "Error", error.response.data.Message);
            } else {
                Alert("danger", "Error", error.response.data.Message);
            }
        });
    }

    const decoratedOnClick = (eventKey) => {
        setOpen(!open);
    }

    useEffect(() => {
        setValidated({number: null, name: null, expiry: null, cvc: null, cp: null});
    }, []);

    useEffect(() => {
        if(type_pay === 1 && handleInputCard !== undefined){ 
            handleInputCard(state, validated);
        }
    }, [state])

    return (
        <>
            <Accordion flush>
                <div className="card famsa-card">
                    <div className="card-header">
                        <Button
                            eventKey="0"
                            type="button"
                            size="lg"
                            className={`${(!open) ? "famsa-btn-none" : "famsa-btn-blue"} famsa-btn-w fw-bold`}
                            onClick={decoratedOnClick}
                        >
                            <Row className='justify-content-center' >
                                <Col md={{ span: 8 }} sm={{ span: 3 }} className="text-start">
                                    <FormattedMessage id="step.three.loan.btn.add" />
                                </Col>
                                <Col md={{ span: 4 }} sm={{ span: 3 }} className="text-end">
                                    {(open) ? <DashLg /> : <PlusLg />}
                                </Col>
                            </Row>
                        </Button>
                    </div>
                    <Accordion.Collapse eventKey={"0"} className={`${(open) ? "show" : ""}`}>
                        <div className="card-body">
                            <Row>
                                <Col md={{ span: 6 }} sm={{ span: 11 }} className="align-self-center mb-3">
                                    <Card
                                        number={state.number}
                                        name={state.name}
                                        expiry={state.expiry}
                                        cvc={state.cvc}
                                        focused={state.focused}
                                        callback={handleCallback}
                                    />
                                </Col>
                                <Col md={{ span: 6 }}>
                                    <form id="formCard">
                                        <Row>
                                            <Col md={{ span: 12 }}>
                                                <Form.Group className="mb-3" controlId="validationCardNumber">
                                                    <Form.Control
                                                        required
                                                        type="tel"
                                                        name="number"
                                                        pattern="[\d| ]{16}"
                                                        placeholder={intl.formatMessage({ id: "step.three.loan.card.number" })}
                                                        value={state.number}
                                                        onChange={(e) => handleChange(e)}
                                                        onFocus={(e) => handleInputFocus(e)}
                                                        isInvalid={(validated.number !== null) ? !validated.number : validated.number}
                                                        isValid={validated.number}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={{ span: 12 }}>
                                                <Form.Group className="mb-3" controlId="validationName">
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        name="name"
                                                        placeholder={intl.formatMessage({ id: "step.three.loan.card.name" })}
                                                        value={state.name}
                                                        onChange={(e) => handleChange(e)}
                                                        onFocus={(e) => handleInputFocus(e)}
                                                        isInvalid={(validated.name !== null) ? !validated.name : validated.name}
                                                        isValid={validated.name}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={{ span: 4 }} sm={{ span: 4 }}>
                                                <Form.Group className="mb-3" controlId="validationExpiry">
                                                    <Form.Control
                                                        required
                                                        type="tel"
                                                        name="expiry"
                                                        pattern="\d\d/\d\d"
                                                        placeholder={intl.formatMessage({ id: "step.three.loan.card.expiry" })}
                                                        value={state.expiry}
                                                        onChange={(e) => handleChange(e)}
                                                        onFocus={(e) => handleInputFocus(e)}
                                                        isInvalid={(validated.expiry !== null) ? !validated.expiry : validated.expiry}
                                                        isValid={validated.expiry}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={{ span: 4 }} sm={{ span: 4 }}>
                                                <Form.Group className="mb-3" controlId="validationCVC">
                                                    <Form.Control
                                                        required
                                                        type="tel"
                                                        name="cvc"
                                                        pattern="\d{3}"
                                                        placeholder={intl.formatMessage({ id: "step.three.loan.card.cvc" })}
                                                        value={state.cvc}
                                                        onChange={(e) => handleChange(e)}
                                                        onFocus={(e) => handleInputFocus(e)}
                                                        isInvalid={(validated.cvc !== null) ? !validated.cvc : validated.cvc}
                                                        isValid={validated.cvc}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={{ span: 4 }} sm={{ span: 4 }}>
                                                <Form.Group className="mb-3" controlId="validationCP">
                                                    <Form.Control
                                                        required
                                                        type="tel"
                                                        name="cp"
                                                        pattern="\d{5}"
                                                        placeholder={intl.formatMessage({ id: "step.three.loan.card.cp" })}
                                                        value={state.cp}
                                                        onChange={(e) => handleChange(e)}
                                                        onFocus={(e) => handleInputFocus(e)}
                                                        isInvalid={(validated.cp !== null) ? !validated.cp : validated.cp}
                                                        isValid={validated.cp}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <input type="hidden" name="issuer" value={state.issuer} />
                                        </Row>
                                        {(type_pay === 2)? 
                                        <Row>
                                            <Col md={{ span: 12 }}>
                                                <Button type="button" className="famsa-btn-w " onClick={(e) => handleSubmit(e)}>
                                                    {(loading) ? 
                                                        <Loading/>
                                                        : 
                                                        <>Add Card</>
                                                    }                                                    
                                                </Button>
                                            </Col>
                                        </Row>
                                        :null}
                                    </form>
                                </Col>
                            </Row>
                        </div>
                    </Accordion.Collapse>
                </div>
            </Accordion>
        </>
    );
}

export default ModalLoan;